import {
  loadObjectFromServer,
  getData,
  postData,
  putData,
  deleteData,
  getDownload,
  patchData
} from "@/utils";

export async function getTemplates() {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  const response = await getData(APP_ROUTES.CAMPAIGNS_EMAIL_TEMPLATES);
  return response;
}

export async function getTemplate(id) {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  const apiUrl = `${APP_ROUTES.CAMPAIGNS_EMAIL_TEMPLATES}${id}/`;
  const response = await getData(apiUrl);
  return response;
}

export async function addTemplate(payload) {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  const response = await postData(
    APP_ROUTES.CAMPAIGNS_EMAIL_TEMPLATES,
    payload
  );
  return response;
}

export async function updateTemplate(id, payload) {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  const apiUrl = `${APP_ROUTES.CAMPAIGNS_EMAIL_TEMPLATES}${id}/`;
  const response = await putData(apiUrl, payload);
  return response;
}

export async function addCampaign(payload) {
  try {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const response = await postData(APP_ROUTES.CAMPAIGNS, payload);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getCampaigns(params) {
  try {
    let queryString = params.location_ids
      .map(location_id => `location_id=${location_id}`)
      .join("&");
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    let apiUrl = `${APP_ROUTES.CAMPAIGNS}?${queryString}`;
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getCampaignList() {
  try {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    let apiUrl = `${APP_ROUTES.CAMPAIGNS}`;
    const response = await getData(apiUrl);
    for(let i = 0; i < response.length; i++) {
      response[i].custom_new_customer = 0
      response[i].custom_new_customerVsAve = 0
      response[i].custom_repeat_customer = 0
      response[i].custom_repeat_customerVsAve = 0
    }
    return response;
  } catch (e) {
    return null;
  }
}
export async function getCampaignSummary() {
  try {
    let apiUrl = '/campaigns/campaigns-summary/';
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function sendCampaign(id) {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  const apiUrl = APP_ROUTES.CAMPAIGNS;
  const response = await postData(`${apiUrl}${id}/send/`);
  return response;
}

export async function getSegmentTypes() {
  // const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  // const apiUrl = APP_ROUTES.CAMPAIGNS;
  // console.log("apiUrl", apiUrl);
  const response = await getData(`/campaigns/segment-types/`);
  return response;
}

export async function getSegments() {
  try {
    let response = await getData(`/campaigns/segments/`);
    let i = 10000
    response.forEach(list => {
      if (list.segmentcache === null) {
        list.segmentcache ={
          "id": i++,
          "all_customers": 0,
          "all_customers_pct": 0,
          "marketable_customers": 0,
          "marketable_pct": 0,
          "trackable_customers": 0,
          "trackable_pct": 0,
          "all_customers_clv": 0,
          "all_customers_annual_clv": 0,
          "marketable_customers_clv": 0,
          "marketable_customers_annual_clv": 0,
          "trackable_customers_clv": 0,
          "trackable_customers_annual_clv": 0,
          "all_customers_clf": 0,
          "marketable_customers_clf": 0,
          "trackable_customers_clf": 0,
          "all_customers_recency": 0,
          "marketable_customers_recency": 0,
          "trackable_customers_recency": 0,
          "segment": 0
        }
      }
    })

    return response;
  } catch (e) {
    return null;
  }
}

export async function getCohortSegments() {
  try {
    const response = await getData(`/campaigns/cohort-segments/`);
    return response;
  } catch (e) {
    return null;
  }
}

export async function addSegments(payload) {
  const response = await postData(`/campaigns/segments/`, payload);
  return response;
}

export async function previewSegment(payload) {
  try {
    const response = await postData(`/campaigns/segments/?preview=1`, payload);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getSegmentsSubscribers(id) {
  const response = await getData(`/campaigns/segments/${id}/subscribers/`);
  return response;
}

export async function removeSegment(id) {
  try {
    const response = await deleteData(`/campaigns/segments/${id}/`);
    return response;
  } catch (e) {
    console.log('Something went wrong (Campaign removeSegment): ', e)
    return null;
  }
}

export async function getSegmentDashboard(id) {
  try {
    const response = await getData(`/benchmark/segment-dashboardv2/${id}/`);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getSegmentObj(id) {
  try {
    const response = await getData(`/campaigns/segments/${id}/`);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getCampaignAnalytics(id) {
  const response = await getData(
    `/benchmark/campaign-analytics/?campaign_id=${id}`
  );
  return response;
}
export async function addFlow(payload) {
  try {
    const response = await postData(`/campaigns/flows/`, payload);
    return response;
  } catch (e) {
    return null;
  }
}
export async function removeFlow(id) {
  try {
    const response = await deleteData(`/campaigns/flows/${id}`);
    return response;
  } catch (e) {
    return null;
  }
}
export async function getFlow(id) {
  try {
    const response = await getData(`/campaigns/flows/${id}`);
    return response;
  } catch (e) {
    return null;
  }
}
export async function getFlows() {
  try {
    const response = await getData(`/campaigns/flows/`);
    return response;
  } catch (e) {
    return null;
  }
}
export async function addFlowTrigger(payload) {
  try {
    const response = await postData(`/campaigns/flows/triggers/`, payload);
    return response;
  } catch (e) {
    return null;
  }
}
export async function updateFlowTrigger(id, payload) {
  try {
    const response = await putData(`/campaigns/flows/triggers/${id}`, payload);
    return response;
  } catch (e) {
    return null;
  }
}
export async function getFlowSequence(id) {
  try {
    const response = await getData(`/campaigns/flows/sequence/${id}`);
    return response;
  } catch (e) {
    return null;
  }
}
export async function addFlowActionEmail(payload) {
  try {
    const response = await postData(`/campaigns/flows/actions/`, payload);
    return response;
  } catch (e) {
    return null;
  }
}
export async function addFlowActionDelay(payload) {
  try {
    const response = await postData(`/campaigns/flows/delays/`, payload);
    return response;
  } catch (e) {
    return null;
  }
}
export async function updateFlowActionEmail(id, payload) {
  try {
    const response = await putData(`/campaigns/flows/actions/${id}`, payload);
    return response;
  } catch (e) {
    return null;
  }
}

export async function updateFlowItem(id, payload) {
  try {
    const response = await putData(`/campaigns/flows/items/${id}`, payload);
    return response;
  } catch (e) {
    return null;
  }
}
export async function removeFlowItem(id) {
  try {
    const response = await deleteData(`/campaigns/flows/items/${id}`);
    return response;
  } catch (e) {
    return null;
  }
}
export async function updateFlowActionDelay(id, payload) {
  try {
    const response = await putData(`/campaigns/flows/delays/${id}`, payload);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getCampaign(id) {
  try {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    let apiUrl = `${APP_ROUTES.CAMPAIGNS}${id}/`;
    const response = await getData(`${apiUrl}`);
    return response;
  } catch (e) {
    return null;
  }
}

export async function updateCampaign(id, payload) {
  try {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    let apiUrl = `${APP_ROUTES.CAMPAIGNS}${id}/`;
    const response = await putData(`${apiUrl}`, payload);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getMenuItem(params) {
  let queryString = Object.keys(params)
    .map(function(key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let apiUrl = `/pos/menu-item/?${queryString}`;
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function addOtherCampaignConfiguration(payload) {
  try {
    if(payload.selectedLocationOrGroup == 'locations'){
      payload.location_groups = [];
    }
    else if(payload.selectedLocationOrGroup == 'location_groups'){
      payload.locations = [];
      let isObject = payload.location_groups.some( 
        value => { return typeof value == "object" } );
      if(isObject){
        let location_groups = [];
        for (let i = 0; i < payload.location_groups.length; i++) {
          let item = payload.location_groups[i];
          if(typeof item == "object"){
            location_groups.push(item.value);
          }
          else{
            location_groups.push(item);
          }
        }
        payload.location_groups = location_groups;
      }
    }
    delete payload.selectedLocationOrGroup;
    const response = await postData(
      `/campaigns/other-campaign-configuration/`,
      payload
    );
    return response;
  } catch (e) {
    return null;
  }
}

export async function updateOtherCampaignConfiguration(id, payload) {
  try {
    const response = await putData(
      `/campaigns/other-campaign-configuration/${id}/`,
      payload
    );
    return response;
  } catch (e) {
    return null;
  }
}

export async function sendTestEmail(payload) {
  try {
    const response = await postData(`/campaigns/send-test/`, payload);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getOtherCampaigns() {
  try {
    const response = await getData(`/campaigns/other-campaign-configuration/`);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getOtherCampaign(id) {
  try {
    const response = await getData(
      `/campaigns/other-campaign-configuration/${id}/`
    );
    return response;
  } catch (e) {
    return null;
  }
}

export async function updateOtherCampaign(id, payload) {
  try {
    if(payload.selectedLocationOrGroup == 'locations'){
      payload.location_groups = [];
    }
    else if(payload.selectedLocationOrGroup == 'location_groups'){
      payload.locations = [];
      let isObject = payload.location_groups.some( 
        value => { return typeof value == "object" } );
      if(isObject){
        let location_groups = [];
        for (let i = 0; i < payload.location_groups.length; i++) {
          let item = payload.location_groups[i];
          if(typeof item == "object"){
            location_groups.push(item.value);
          }
          else{
            location_groups.push(item);
          }
        }
        payload.location_groups = location_groups;
      }
    }
    delete payload.selectedLocationOrGroup;
    const response = await putData(
      `/campaigns/other-campaign-configuration/${id}/`,
      payload
    );
    return response;
  } catch (e) {
    return null;
  }
}

export async function removeCampaigns(id) {
  try {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    let apiUrl = `${APP_ROUTES.CAMPAIGNS}${id}/`;
    const response = await deleteData(`${apiUrl}`);
    return response;
  } catch (e) {
    return null;
  }
}

export async function updateFlow(id, payload) {
  try {
    const response = await putData(`/campaigns/flows/${id}`, payload);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getRevenueCenters() {
  try {
    const response = await getData(`/pos/revenue-centers/`);
    return response;
  } catch (e) {
    return null;
  }
}

export async function setOtherCampaignControlSotres(id,payload) {
  try {
    
    const response = await putData(
      `/campaigns/other-campaign-control-stores/${id}/`,
      payload
    );
    return response;
  } catch (e) {
    return null;
  }
}

export async function getOtherCampaignControlSotres(id) {
  try {
    
    const response = await getData(`/campaigns/other-campaign-control-stores/${id}/`);
    return response;
  } catch (e) {
    return null;
  }
}

export async function initiateSegmentExport(segment_id) {
  try {
    const response = await getData(`/campaigns/segments/${segment_id}/export/?trigger=1`);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getExportById(id) {
  try {
    const response = await getData(`/campaigns/segments/${id}/export/`);
    return response;
  } catch (e) {
    return null;
  }
}
export async function sendSegmentViaEmailById(id, email) {
  try {
    const response = await getData(`/campaigns/segments/${id}/export/?email=${email}`);
    return response;
  } catch (e) {
    return null;
  }
}
export async function createCampaignBySendgrid(payload) {
  const response = await postData(`/campaigns/email-campaigns/`, payload);
  return response;
}

export async function updateCampaignBySendgrid(payload) {
  const response = await patchData(`/campaigns/email-campaigns/`, payload);
  return response;
}

export async function getCampaignListV2() {
  try {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    let apiUrl = `/campaigns/email-campaigns/`;
    const response = await getData(apiUrl);
    for(let i = 0; i < response.length; i++) {
      response[i].custom_new_customer = 0
      response[i].custom_new_customerVsAve = 0
      response[i].custom_repeat_customer = 0
      response[i].custom_repeat_customerVsAve = 0
    }
    return response;
  } catch (e) {
    return null;
  }
}

export async function getMenuList() {
  try {

    let queryString = ''
    const apiUrl = `/bigdata/menu-items/`;
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getMenuCategoryList() {
  try {

    let queryString = ''
    const apiUrl = `/bigdata/menu-category/`;
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}